import axios from 'axios'
import cache from '@/assets/js/lib/cache.js'

export function getCarsList (params = {}) {
  return axios.get(`${ window.apiRobot }/web/page/query/info`, {
    params,
    adapter: cache(), // 返回一个promise
  })
}
